import { createContext, useContext } from "react";

export const HlsContext = createContext({
  Hls: {},
  hls: {},
  removeHLS: () => {},
  setUpVideoSource: () => {}
});

export const useHlsContext = () => useContext(HlsContext);
